import { AppButton } from '@/shared/ui/button'
import { useStyles } from './styles'
import { useState } from 'react'
import { goToAuth, goToConnectPlatform, goToMain, goToTon } from '@/app/routing/events'
import { $tgAccuntData, $userLanguage, $userToken, authUserFx } from '@/entities/user'
import { useUnit } from 'effector-react'
import { lang } from '@/shared/constants/lang'
import Break from '@/shared/ui/break'
import { Icon } from '@/shared/ui/icon'
import { IconProps } from '@/shared/ui/icon'
import { userSteamSettings } from './constants'
import WebApp from '@twa-dev/sdk'
import { useBackButton } from '@/shared/hooks/useBackButton'
import { useHideNav } from '@/shared/hooks/useHideNav'

export type ViewType = IconProps['view']
type Settings = {
  inventory: string
  details: string
  friends: string
  game: string
}
const ErrorPrivateView = () => {
  useHideNav()
  const { classes } = useStyles({})
  const userLang = useUnit($userLanguage)
  const texts = lang[userLang].pages.errors.private
  const [isLoading, setIsLoading] = useState(false)

  useBackButton({ onBack: goToMain })

  const handleRefresh = () => {
    setIsLoading(true)
    setTimeout(() => {
      goToAuth()
    }, 1000)
  }

  return (
    <div className={classes.backdrop}>
      <div className={classes.root}>
        <div className={classes.title}>
          <h2>{texts.title}</h2>
          <p>{texts.sub_title}</p>
        </div>
        <Break />
        <div className={classes.textWlink}>{texts.text_w_link}</div>
        <div className={classes.settings}>
          <div className={classes.largeSettingsContainer}>
            <div className={classes.iconAndTitleWrapper}>
              <Icon view="privatePerson" />
              {texts.my_profile}
            </div>
            <div className={classes.publicPrivate}>
              <span className={classes.private}>{texts.private}</span>
              <img
                src="/assets/svg/arrow2.svg"
                alt=""
              />
              <span className={classes.public}>{texts.public}</span>
            </div>
          </div>
          <div className={classes.tinySettingsWrapper}>
            {userSteamSettings.map((setting) => (
              <div className={classes.settingContainer}>
                <Icon view={setting.icon as ViewType} />
                <span>{texts.settings[setting.key as keyof Settings]}</span>
              </div>
            ))}
          </div>
        </div>
        <Break />
        <span className={classes.textWlink}>{texts.will_enalbe}</span>

        <div className={classes.buttonsWrapper}>
          <AppButton
            fullWidth
            className={classes.refreshButton}
            onClick={() => WebApp.openLink('https://steamcommunity.com/my/edit/settings', { try_instant_view: true })}
            style={{ color: 'white' }}
            variant="secondary"
          >
            <span>{texts.manage_settings}</span>
          </AppButton>
          <AppButton
            fullWidth
            className={classes.refreshButton}
            isLoading={isLoading}
            onClick={handleRefresh}
          >
            <span>{texts.refresh}</span>
          </AppButton>
        </div>
      </div>
    </div>
  )
}

const NetError = () => {
  useHideNav()

  const userToken = useUnit($userToken)
  const userLang = useUnit($userLanguage)
  const tgAccountData = useUnit($tgAccuntData) ?? null

  const { classes } = useStyles({})

  const texts = lang[userLang].pages.errors.smth_went_wrong
  const [isLoading, setIsLoading] = useState(false)

  const handleClick = () => {
    try {
      setIsLoading(true)
      if (userToken) {
        authUserFx({ init_data: WebApp.initData })
      }
    } catch (e) {
      console.error(e)
    } finally {
      setTimeout(() => {
        setIsLoading(false)
        goToMain()
      }, 2000)
    }
  }

  return (
    <div className={classes.backdrop}>
      <div className={classes.root}>
        <div className={classes.title}>
          <h2>{texts.title}</h2>
          <p>{texts.sub_title}</p>
        </div>
        <Break />
        <div className={classes.textWlink}>
          <p>{texts.text}</p>
        </div>

        <div className={classes.textWlink}>{texts.tip}</div>

        <div className={classes.button}>
          <AppButton
            disabled={isLoading}
            fullWidth={true}
            isLoading={isLoading}
            onClick={() => handleClick()}
            sx={{ height: '50px' }}
          >
            {texts.btnText}
          </AppButton>
        </div>
        <div className={classes.tidWrapper}>
          <span style={{ color: 'rgba(255, 255, 255, 0.05)', fontSize: '12px' }}>{tgAccountData?.user.tid}</span>
        </div>
      </div>
    </div>
  )
}

const DoubleConnectionError = () => {
  useHideNav()
  const { classes } = useStyles()
  // const userLang = useUnit($userLanguage)
  // const texts = lang[userLang].pages.errors.doubleConnection
  // const [isLoading, setIsLoading] = useState(false)

  return (
    <div className={classes.doubleConnectionRoot}>
      <img
        className={classes.doubleConnectionBG}
        src="/assets/backgrounds/StartBG.webp"
      />
      <div className={classes.doubleConnectionContent}>
        <div className={classes.headingAndSteamWrapper}>
          <img
            src="/assets/social/steam.webp"
            alt=""
            style={{ width: '32px', height: '32px' }}
          />
          {/* <span className={classes.heading}>{texts.heading}</span> */}
        </div>
        <div>
          {/* <div className={classes.description}>{texts.description}</div> */}
          {/* <div className={classes.description}>{texts.twice}</div> */}
        </div>

        <div className={classes.doubleConnectionButtonsWrapper}>
          <AppButton
            onClick={() => goToConnectPlatform({ platform: 'steam' })}
            className={classes.connectAnotherButton}
          >
            Another
            {/* {texts.connect_another} */}
          </AppButton>
          <AppButton
            onClick={() => goToTon()}
            className={classes.continueWithoutButton}
          >
            W/o
            {/* {texts.continue_withiout} */}
          </AppButton>
        </div>
      </div>
    </div>
  )
}

export { ErrorPrivateView, NetError, DoubleConnectionError }
